import { defineStore } from 'pinia';
import { ref } from 'vue';

export type Theme = 'pro-circuit' | 'bullseye' | 'digital-hub' | 'geek';

export const THEMES: { id: Theme; label: string; description: string; primary: string; accent: string; bg: string }[] = [
  {
    id: 'pro-circuit',
    label: 'Pro Circuit',
    description: 'Navy & Or (Style compétition officielle)',
    primary: '#1e3a5f',
    accent: '#eab308',
    bg: '#f0f4f8',
  },
  {
    id: 'bullseye',
    label: 'Bullseye',
    description: 'Sombre & Rouge (Look premium esport)',
    primary: '#dc2626',
    accent: '#f59e0b',
    bg: '#1e293b',
  },
  {
    id: 'digital-hub',
    label: 'Digital Hub',
    description: 'Indigo & Cyan (Plateforme tech moderne)',
    primary: '#4f46e5',
    accent: '#22d3ee',
    bg: '#0f172a',
  },
  {
    id: 'geek',
    label: 'Geek',
    description: 'Terminal vert (Mode hardcore)',
    primary: '#00ff00',
    accent: 'cyan',
    bg: '#000000',
  },
];

const VALID_THEMES: Theme[] = ['pro-circuit', 'bullseye', 'digital-hub', 'geek'];

export const useThemeStore = defineStore('theme', () => {
  const saved = localStorage.getItem('dh-theme') as Theme | null;
  const initial: Theme = saved && VALID_THEMES.includes(saved) ? saved : 'pro-circuit';

  const currentTheme = ref<Theme>(initial);

  const setTheme = (theme: Theme) => {
    currentTheme.value = theme;
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('dh-theme', theme);
  };

  // Apply immediately on store creation
  setTheme(initial);

  return { currentTheme, setTheme, THEMES };
});
